<template>
  <component :is="blogData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="blogData === undefined">
      <h4 class="alert-heading">獲取通告數據時出錯</h4>
      <div class="alert-body">
        找不到相關通告記錄。請查看
        <b-link class="alert-link" :to="{ name: 'blogs-list' }">
          通告名單
        </b-link>
      </div>
    </b-alert>

    <blog-edit-tab-information
      v-if="blogData"
      :blog-data="blogData"
      class="p-sm-2"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import blogStoreModule from "../blogStoreModule";
import BlogEditTabInformation from "./blogEditTabInformation.vue";

export default {
  components: {
    BlogEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const blogData = ref({});
    const blog = {
      id: 0,
      is_active: true,
      blog_date: null,
      content: null,
      title: null,
    };

    const PRODUCT_APP_STORE_MODULE_NAME = "blog";

    if (!store.hasModule(PRODUCT_APP_STORE_MODULE_NAME))
      store.registerModule(PRODUCT_APP_STORE_MODULE_NAME, blogStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PRODUCT_APP_STORE_MODULE_NAME))
        store.unregisterModule(PRODUCT_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "blog-create") {
        blogData.value = blog;
      } else {
       
        store
          .dispatch("blog/fetchBlog", { id: router.currentRoute.params.id })
          .then((response) => {
            blogData.value = response.data.blog;
            console.log(blogData.value)
          })
          .catch((error) => {
            console.log("error when fetching blog", error);
            if (error.response.status === 404) {
              blogData.value = undefined;
            }
          });
      }
    };




    onMounted(() => {
      refetchData();
    });

    return {
      blogData,
    };
  },
};
</script>
